export function Save(): JSX.Element {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
      <path
        fill="#fff"
        d="M12.167.5h-10C1.242.5.5 1.25.5 2.167v11.666c0 .917.742 1.667 1.667 1.667h11.666c.917 0 1.667-.75 1.667-1.667v-10L12.167.5Zm1.666 13.333H2.167V2.167h9.308l2.358 2.358v9.308ZM8 8a2.497 2.497 0 0 0-2.5 2.5C5.5 11.883 6.617 13 8 13s2.5-1.117 2.5-2.5S9.383 8 8 8ZM3 3h7.5v3.333H3V3Z"
      />
    </svg>
  );
}
